import { createReducer, on } from '@ngrx/store';
import * as GeneralSettingsActions from './general-settings.actions';
import { initialGeneralSettingsState } from './general-settings.state';

export const generalSettingsReducer = createReducer(
  initialGeneralSettingsState,
  on(GeneralSettingsActions.setGeneralSettingsData, (state, { data }) => ({
    ...state,
    ...data,
  })),
  on(GeneralSettingsActions.clearGeneralSettingsData, (state) => ({
    ...state,
    ...initialGeneralSettingsState,
  }))
);
